<div class="pt-3">
    You've chosen the project type <strong>{{selectedProjectType$ | async}}</strong>.
    EstiMate's time frame recommendation will be highlighted with * if
    available.
    <br>
    <div class="pt-3">
        <strong>Extracted Estimation Assumptions</strong>
        <ul>
            <ng-container *ngFor="let detail of timeSensitiveDetails$ | async">
                <li>{{ detail }}</li>
            </ng-container>
        </ul>
    </div>
    <strong>Select an approx. time frame for your project to continue or
        re-estimate.</strong>
    <mat-grid-list cols="3" rowHeight="2:1">
        <ng-container *ngFor="let timeFrame of timeFrameEstimate$ | async">
            <mat-grid-tile>
                <button
                    [ngClass]="{
                    'greenbtn': (selectedTimeFrame$ | async) === timeFrame, 
                    'bluebtn': timeFrame.includes('*') && (selectedTimeFrame$ | async) !== timeFrame,
                    'blackbtn': !timeFrame.includes('*') && (selectedTimeFrame$ | async) !== timeFrame}"
                    class=" btn input-element button-bottom w-75"
                    (click)="selectTimeFrame(timeFrame, true)">
                    {{ addTitle(timeFrame) }}
                </button>
            </mat-grid-tile>
        </ng-container>
    </mat-grid-list>
</div>
<div class="d-flex align-items-center mt-3 mb-3">
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend blue-circle"></div>
        <span class="legend-text ml-2">Recommendation</span>
    </div>
    <div class="d-flex align-items-center mr-2">
        <div class="circle-legend green-second-circle"></div>
        <span class="legend-text ml-2">Selection</span>
    </div>
</div>